import React from 'react';

/**
 * 자산 내역 컴포넌트 속성 패널 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤을 정의합니다.
 */
const AssetHistoryProperties = [
  {
    group: '기본 설정',
    properties: [
      {
        name: 'componentProps.title',
        label: '제목',
        control: 'TextField',
        defaultValue: '자산 내역'
      },
      {
        name: 'componentProps.emptyText',
        label: '내역 없음 메시지',
        control: 'TextField',
        defaultValue: '자산 내역이 없습니다.'
      }
    ]
  },
  {
    group: '스타일',
    properties: [
      {
        name: 'style.padding',
        label: '패딩',
        control: 'TextField',
        defaultValue: '30px 0'
      },
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: '#ffffff'
      },
      {
        name: 'style.borderRadius',
        label: '테두리 둥글기',
        control: 'TextField',
        defaultValue: '8px'
      },
      {
        name: 'style.boxShadow',
        label: '그림자',
        control: 'TextField',
        defaultValue: '0 2px 10px rgba(0, 0, 0, 0.1)'
      },
      {
        name: 'style.fontFamily',
        label: '글꼴',
        control: 'TextField',
        defaultValue: 'Noto Sans KR, sans-serif'
      },
      {
        name: 'style.maxWidth',
        label: '최대 너비',
        control: 'TextField',
        defaultValue: '100%'
      },
      {
        name: 'style.margin',
        label: '마진',
        control: 'TextField',
        defaultValue: '0 auto'
      }
    ]
  },
  {
    group: '고급 설정',
    properties: [
      {
        name: 'className',
        label: '클래스명',
        control: 'TextField',
        defaultValue: 'mileage-history-wrapper padding-tb-40'
      }
    ]
  }
];

export default AssetHistoryProperties; 